import { addCSRFQuery } from '../../utils/csrf';
import { getHomeChatBrokerWSEndPoint } from '../../utils/getServerUrl';
import { HOME_CHAT_BROKER_URL_KEY } from '../../utils/localstorage-keys';

/** Like every other app websocket: the session cookie rides the upgrade, app checks it with the csrf token. */
export function resolveHomeChatBrokerUrl(): string {
  return localStorage.getItem(HOME_CHAT_BROKER_URL_KEY) || addCSRFQuery(getHomeChatBrokerWSEndPoint());
}

export async function getHomeChatBrokerUrl(): Promise<string> {
  return resolveHomeChatBrokerUrl();
}
